<ion-header class="ion-no-border">
  <!-- <ion-navbar>
      <ion-buttons left>
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{(serviceDetail.id) ? 'Edit service' : "Create a service"}}
    </ion-title>
  </ion-navbar> -->

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ serviceDetail.id ? "Edit service" : "Create a service" }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form [formGroup]="serviceDetailForm">
    <ion-item lines="none">
      <ion-label position="stacked">Service name</ion-label>
      <ion-input
        type="text"
        name=""
        formControlName="serviceName"
        clearInput
      ></ion-input>
    </ion-item>

    <ion-item *ngIf="!serviceName.valid && submitAttempt" lines="none">
      <p *ngIf="serviceName.hasError('required')" class="sm-error">
        Service name is required.
      </p>
    </ion-item>

    <ion-item tappable (click)="showServiceCategoryPicker()" lines="none">
      <ion-label class="ion-margin-bottom sm-label">Service Category</ion-label>
      <h4>
        {{
          serviceDetail.getServiceCategory()
            ? serviceDetail.getServiceCategory().categoryName
            : "Select a service category"
        }}
      </h4>
      <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
    </ion-item>

    <ion-item
      *ngIf="!serviceDetail.serviceCategory && submitAttempt"
      lines="none"
    >
      <p class="sm-error">Service Category is required.</p>
    </ion-item>

    <!-- <ion-item [hidden]="serviceCategory.valid || (serviceCategory.pristine && !submitted)">
      <p *ngIf="serviceCategory.hasError('required')" class='sm-error'>
        Service category is required.
      </p>
    </ion-item> -->

    <!-- <ion-item> -->
    <!-- <ion-label stacked>Price {{currency}}</ion-label> -->
    <!-- <ion-input type="number" name='' formControlName="price" clearInput></ion-input> -->
    <!-- </ion-item> -->

    <ion-item lines="none">
      <ion-label position="stacked">Price</ion-label>
      <ion-input
        [maskito]="currencyMask"
        [maskitoElement]="maskPredicate"
        formControlName="price"
        placeholder="Enter your service price"
      >
      </ion-input>
    </ion-item>

    <ion-item *ngIf="!price.valid && submitAttempt" lines="none">
      <p *ngIf="price.hasError('required')" class="sm-error">
        Price is required.
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label>Bookback/Processing</ion-label>
      <ion-toggle
        formControlName="bookback"
        (ionChange)="onBookBackToggle($event)"
      ></ion-toggle>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Duration</ion-label>
      <ion-select
        interface="popover"
        mode="ios"
        formControlName="startDuration"
      >
        <ion-select-option
          *ngFor="let timeslot of timeSlots"
          [value]="timeslot.value"
        >
          {{ timeslot.label }}
        </ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item *ngIf="!startDuration.valid && submitAttempt" lines="none">
      <p *ngIf="startDuration.hasError('required')" class="sm-error">
        Start Duration is required.
      </p>
    </ion-item>

    <div *ngIf="serviceDetail.isBookBack()">
      <ion-item lines="none">
        <ion-label position="stacked">Process Duration</ion-label>
        <ion-select
          interface="popover"
          mode="ios"
          formControlName="processDuration"
        >
          <ion-select-option
            *ngFor="let timeslot of timeSlots"
            [value]="timeslot.value"
          >
            {{ timeslot.label }}
          </ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked">Finish Duration</ion-label>
        <ion-select formControlName="finishDuration">
          <ion-select-option
            *ngFor="let timeslot of timeSlots"
            [value]="timeslot.value"
          >
            {{ timeslot.label }}
          </ion-select-option>
        </ion-select>
      </ion-item>
    </div>

    <ion-item lines="none">
      <ion-label>Client Bookable</ion-label>
      <ion-toggle formControlName="clientBookable"></ion-toggle>
    </ion-item>

    <ion-button
      fill="clear"
      expand="block"
      color="danger"
      *ngIf="serviceDetail.id"
      (click)="onDeleteService()"
      >Remove from my services</ion-button
    >
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar class="ion-no-padding">
    <ion-row>
      <ion-col>
        <ion-button
        color="primary"
        expand="block"
        ng-reflect-color="primary"
          (click)="onServiceDetailFormSave()"
        >
          Save
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
